import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  StatusBar, SafeAreaView, StyleSheet, View, ScrollView,
} from 'react-native';
import Header from '../components/Header';
import VideoModal from '../components/VideoModal';
import GradientButton from '../components/GradientButton';
import APMStyles from '../styles';
import ExerciseCard from '../components/ExerciseCard';

function Workout({ navigation }) {
  const { exercises } = useSelector((state) => state.training.workout);

  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [video, setVideo] = useState('');

  function watchVideo(videoUrl) {
    setVideo(videoUrl);
    setVideoModalOpen(true);
  }

  return (
    <View style={styles.container}>
      <SafeAreaView style={styles.header}>
        <StatusBar barStyle="dark-content" />
        <Header backButton style={styles.header} navigation={navigation} />
      </SafeAreaView>

      <View style={styles.content}>
        <ScrollView>
          <VideoModal
            video={video}
            visible={videoModalOpen}
            closeModal={() => setVideoModalOpen(false)}
          />
          {
            exercises && exercises.map((exercise) => (
              <ExerciseCard
                key={exercise.exercise.name}
                backgroundImg={exercise.exercise.gif}
                title={exercise.exercise.name.toUpperCase()}
                subtitle={exercise.directions.toUpperCase()}
                watchVideo={() => watchVideo(exercise.exercise.video)}
                description={exercise.exercise.text}
              />
            ))
          }
        </ScrollView>
      </View>

      <View style={styles.buttonContainer}>
        <GradientButton
          onPress={() => navigation.navigate('WorkoutComplete')}
        >
          COMPLETE WORKOUT
        </GradientButton>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: APMStyles.colors.background,
  },
  header: {
    flex: 1,
  },
  content: {
    flex: 10,
    marginTop: 2,
  },
  buttonContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  button: {
    height: 50,
    width: 250,
    justifyContent: 'center',
  },
  title: {
    letterSpacing: 2,
    fontSize: APMStyles.typography.title,
    color: APMStyles.colors.text,
  },
  paragraph: {
    fontSize: APMStyles.typography.paragraph,
    color: APMStyles.colors.text,
  },
  card: {
    backgroundColor: APMStyles.colors.background,
  },
});

export default Workout;
